import React from 'react';
import SignupComp from '../../components/auth/SignupComp';
import tenant from "../../assets/tenant.png"

const TenantSignup = () => {
  return (
    <div>
        <SignupComp text={"Tenant"} img={tenant} />
    </div>
  )
}

export default TenantSignup